<template>
  <a-tabs v-model:activeKey="activeKey">
    <a-tab-pane key="1" tab="经营者">
      <optionator/>
    </a-tab-pane>
    <a-tab-pane key="2" force-render tab="房源登记">
      <HousePage/>
    </a-tab-pane>
    <a-tab-pane key="3" tab="门锁安装">
      <lock/>
    </a-tab-pane>
    <a-tab-pane key="4" tab="入住登记">
      <CheckinPage/>
    </a-tab-pane>
    <a-tab-pane key="5" tab="入住人登记">
      <tenant/>
    </a-tab-pane>
    <a-tab-pane key="6" tab="开门记录">
      <OpenDoorPage/>
    </a-tab-pane>
    <a-tab-pane key="7" tab="数据统计">
      <reportStat/>
    </a-tab-pane>
  </a-tabs>
</template>

<script>
import optionator from './operator.vue';
import HousePage from './house.vue';
import lock from './lock.vue';
import CheckinPage from './checkIn.vue';
import tenant from './tenant.vue';
import OpenDoorPage from './openDoor.vue';
import reportStat from './reportStat.vue';

import {ref} from 'vue';
// eslint-disable-next-line no-unused-vars
const activeKey = ref('1');
export default {
  components: {
    HousePage, CheckinPage, optionator, OpenDoorPage, tenant, lock, reportStat
  },
};
</script>
<style>
</style>
